import React from "react";

// Cabeçalho de página: título de um lado, ações do outro.
//
// No celular os dois não cabem lado a lado — as ações desciam para fora da
// tela e sumiam. Por isso o `flex-wrap`: o bloco de botões cai para a linha
// de baixo em vez de escapar pela direita. O recuo também encolhe, senão as
// bordas comem a largura útil de uma tela de 390px.
const MainHeader = ({ children }) => {
	return (
		<div className="flex flex-wrap items-center gap-x-3 gap-y-2 px-4 pt-4 pb-3 sm:px-6 sm:pt-6 sm:pb-4">
			{children}
		</div>
	);
};

export default MainHeader;
